import {SessaoViewModel} from '../../../../model/sessao/sessao-view-Model';

import {Injectable} from '@angular/core';

import jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class jwtAuthService {
  constructor() {}

  //pegas as RULES  no token JWT do user que esta Logado
  //suporte https://code-maze.com/angular-role-based-authorization-with-aspnet-identity/
  pegarRulesDoUsuarioLogado(): string {
    let token = this.getAuthorizationToken();
    const decoded: any = this.jwtDecodeToken(token);
    const role = decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    return role;
  }

  sessaoService(): any {
    let sessaVM = new SessaoViewModel();

    let token = this.getAuthorizationToken();
    const decoded: any = this.jwtDecodeToken(token);

    sessaVM == decoded;
    return decoded;
  }

  jwtDecodeToken(token: string | null): any {
    return jwt_decode(token as string);
  }

  //Responsaveis por gerenciar o JWT, e autg guard que esta no AuthGuard
  //Buscar a data de Experição do TOKEN que veio o Back
  buscarDataExpiracaoToken(token: string): Date {
    const decoded: any = this.jwtDecodeToken(token);

    if (decoded.exp === undefined) {
      return null as any;
    }

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  IsTokenExpirado(token?: string): boolean {
    if (!token) return true;

    const date = this.buscarDataExpiracaoToken(token);
    if (date === undefined) return false;
    return !(date.valueOf() > new Date().valueOf());
  }

  getAuthorizationToken() {
    const tokenRecuperado = window.localStorage.getItem('Bearer');
    return tokenRecuperado;
  }

  isUsuarioLogado() {
    const token = this.getAuthorizationToken();
    if (!token) return false;
    else if (this.IsTokenExpirado(token)) return false;

    return true;
  }

  onlogOut() {
    return new Promise(resolve => {
      window.localStorage.clear();
      resolve(true);
    });
  }
}
